import './Home.css';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

const heroSlides = [
  {
    img: "/assets/HeroSlide.jpg",
    title: "Create Beautiful, Lasting Memories",
    subtitle: "Custom photo books designed, printed, and delivered with love.",
  },
  {
    img: "/assets/HeroSlide2.jpg",
    title: "Design It Your Way",
    subtitle: "Fully personalized albums with premium finishing.",
  },
  {
    img: "/assets/HeroSlide3.jpg",
    title: "Your Story, Our Craft",
    subtitle: "Preserving your moments in print.",
  },
  {
    img: "/assets/HeroSlide4.jpg",
    title: "Elegant. Emotional. Everlasting.",
    subtitle: "A photobook that speaks your journey.",
  }
];

export default function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [imgLoaded, setImgLoaded] = useState(false);
  const [bgUrl, setBgUrl] = useState(heroSlides?.[0]?.img || "");

  useEffect(() => {
    let cancelled = false;
    setImgLoaded(false);

    const src = heroSlides[currentSlide].img;
    const img = new Image();
    img.src = src;

    const show = () => {
      if (cancelled) return;
      // swap background only when the new image is fully decoded
      setBgUrl(src);
      setImgLoaded(true);
    };

    if (img.decode) {
      img.decode().then(show).catch(show); // decode() is crisp; fall back to onload if needed
    } else {
      img.onload = show;
      img.onerror = show; // don’t hang the UI if load fails
    }

    return () => {
      cancelled = true;
    };
  }, [currentSlide, heroSlides]);


  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="home-container">

      {/* HERO SLIDER */}
      <section className="hero-slider">
        <div
          className={`hero-slide ${imgLoaded ? "image-ready" : "is-loading"}`}
          style={{ backgroundImage: `url(${bgUrl})` }}
        >
          <div className="hero-text">
            <h1>{heroSlides[currentSlide].title}</h1>
            <p>{heroSlides[currentSlide].subtitle}</p>
            <Link to="/catalog" className="primary-btn">Explore Our Catalog</Link>
          </div>
        </div>
      </section>

      {/* === rest of your existing content remains unchanged === */}
      {/* SERVICE HIGHLIGHT */}
      <section className="section two-column">
        <div className="text">
          <h2>Design Your Own Photobook</h2>
          <p>
            Whether it's a wedding, vacation, baby’s first year, or a heartfelt gift — we bring your vision to life. Choose layouts, colors, captions, and finishes that reflect your story.
          </p>
          <Link to="/contact#contact-form" className="cta-button">
            Start Your Design
          </Link>
        </div>
        <div className="image">
          <img src="/assets/Catalog/Fleecy Glam3/Technozappy Studio 36.jpg" alt="Custom Design" />
        </div>
      </section>

      {/* THEMES */}
      <section className="section themes">
        <h2>Choose a Theme That Tells Your Story</h2>
        <div className="theme-cards">
          <div className="card">
            <img src="/assets/weddingmain.jpg" alt="Wedding" />
            <h3>Wedding</h3>
          </div>
          <div className="card">
            <img src="/assets/Catalog/New Product2/Technozappy Studio 9a.jpg" alt="Baby" />
            <h3>Baby's First Year</h3>
          </div>
          <div className="card">
            <img src="/assets/travel1.png" alt="Travel" />
            <h3>Travel</h3>
          </div>
          <div className="card">
            <img src="/assets/family2.jpg" alt="Family" />
            <h3>Family</h3>
          </div>
        </div>
      </section>

      {/* VIDEO PREVIEW */}
      <section className="section video-feature">
          <h2>Experience What’s New and Exciting at WePrint PhotoBooks</h2>
          <div className="video-row">
            {[
              'https://www.youtube.com/embed/DuTFSxeVA7s',
              'https://www.youtube.com/embed/rdXhun42DEs',
              'https://www.youtube.com/embed/5oS7LQBtr14'
            ].map((src, i) => (
              <div className="video-box" key={i}>
                <div className="responsive-video">
                  <iframe
                    width="100%"
                    height="100%"
                    src={src}
                    title={`Video ${i + 1}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
              </div>
            ))}
          </div>
        </section>

      {/* INSTAGRAM FEED */}
      {/* <section className="section insta-feed">
        <h2>Snapshots from Our Customers</h2>
        <div className="insta-grid">
          {Array.from({ length: 8 }).map((_, i) => (
            <img key={i} src="/assets/family.jpg" alt={`Customer snapshot ${i + 1}`} />
          ))}
        </div>
      </section> */}

      {/* TESTIMONIAL TEASER */}
      <section className="section testimonials-preview">
        <h2>What Our Customers Say</h2>
        <div className="testimonial-cards">
          <div className="card">
            <p>"The perfect gift for our wedding guests. The quality blew us away!"</p>
            <strong>- Aditi</strong>
          </div>
          <div className="card">
            <p>"My travel photobook is a keepsake I’ll treasure forever."</p>
            <strong>- Rohan</strong>
          </div>
        </div>
        <Link to="/testimonials" className="secondary-btn">Read More Reviews</Link>
      </section>

      {/* FINAL CTA */}
      <section className="section cta-highlight">
        <h2>Ready to Start Yours?</h2>
        <p>Book a free consultation or visit our store to begin crafting your custom photobook today.</p>
        <Link to="/contact#contact-form" className="primary-btn">Get in Touch</Link>
      </section>
    </div>
  );
}
